/**
 * Cognito service selector - exports either real Cognito service or mock
 * based on configuration.
 */

import config from '../config/config';
import realCognitoService from './cognitoReal';
import mockCognitoService from './cognitoMock';

// Export the appropriate Cognito service based on configuration
const cognitoService = config.features.authEnabled ? realCognitoService : mockCognitoService;

// Log which service is being used
if (config.features.authEnabled) {
  console.log('🔐 Using Real Cognito Service');
} else {
  console.log('🎭 Using Mock Cognito Service for development');
}

export default cognitoService;
